import React from 'react';
import { Pagination } from 'antd';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { withQuotationReducer } from 'containers/Quotations/withReducer';

import { makeSelectPaginator } from 'containers/Quotations/selectors';
import { setPage } from 'containers/Quotations/actions';

import 'antComponentsStyle';
import './styles.scss';

class Paginator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: this.props.paginator.currentPage || 1
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.paginator.currentPage !== this.props.paginator.currentPage) {
      this.setState({currentPage: this.props.paginator.currentPage})
    }
  }

  pageItemRender = (current, type, originalElement) => {
    if (type === 'prev') {
      return <a>Indietro</a>;
    }
    if (type === 'next') {
      return <a>Avanti</a>;
    }
    return originalElement;
  }

  setPage = page => {
    this.props.setPage(page);
    this.setState({currentPage: page})
  }

  render() {
    const { paginator } = this.props;
    const { currentPage } = this.state;

    return (
      <div id="Paginator" className="rentals-list-w">
        <div className=" mx-auto text-center">
          <div className="pagination-w">
            <div className="pagination-links">
              <ul className="pagination">
                <Pagination
                  defaultCurrent={currentPage}
                  total={paginator.total}
                  onChange={this.props.setPage}
                  itemRender={this.pageItemRender}
                  size="small"
                  showTitle={false}
                  pageSize={10}
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Paginator.defaultProps = {};
Paginator.propTypes = {};

const mapStateToProps = createStructuredSelector({
  paginator: makeSelectPaginator(),
});
export function mapDispatchToProps(dispatch) {
  return {
    setPage: pageNumber => dispatch(setPage(pageNumber)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withQuotationReducer,
  withConnect,
)(Paginator);
